import * as React from "react";

import { cn } from "@/lib/utils";

// Figma "Filter Chip" (ver.6): Default = white + 1px #E6E6E3 / 400, Selected = #FFF5ED + 1px #FD5108 / 700. Radius 8, height 35.
export interface NvFilterChipProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  selected?: boolean;
}

const NvFilterChip = React.forwardRef<HTMLButtonElement, NvFilterChipProps>(
  ({ className, selected = false, type = "button", ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      aria-pressed={selected}
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-nv-chip border px-3 py-[6px] text-nv-tag transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nv-brand disabled:pointer-events-none disabled:opacity-40",
        selected
          ? "border-nv-brand bg-nv-brand-subtle font-bold text-nv-text-primary"
          : "border-nv-border bg-nv-surface text-nv-text-primary hover:border-nv-border-strong",
        className,
      )}
      {...props}
    />
  ),
);
NvFilterChip.displayName = "NvFilterChip";

export { NvFilterChip };
